import { createApi } from '@reduxjs/toolkit/query/react';
import { createApiConfig } from '../../createApiConfig';

export const uMGroupsApi = createApi({
  reducerPath: 'uMGroupsApi',
  ...createApiConfig(process.env.REACT_APP_API_BASE_URL),
  tagTypes: ['Groups'],
  endpoints: (builder) => ({
    listGroups: builder.query({
      query: (params) => ({
        url: `users/groups/`,
        params,
      }),
      providesTags: ['Groups'],
    }),
    createGroup: builder.mutation({
      query: (data) => ({
        url: `users/groups/`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['Groups'],
    }),
    updateGroup: builder.mutation({
      query: ({ id, data }) => ({
        url: `users/groups/${id}/`,
        method: 'PATCH',
        body: data,
      }),
      invalidatesTags: ['Groups'],
    }),
  }),
});

export const {
  useListGroupsQuery,
  useCreateGroupMutation,
  useUpdateGroupMutation,
} = uMGroupsApi;
